/**
 * Which side of a fee negotiation took an action.
 *
 * Only two parties exist: the merchant proposing a rate, and Afriex (Sales or
 * Finance) answering it. Deliberately not the maker/checker vocabulary: this
 * is an agreement between two parties, not one party's internal approval, so
 * neither side is "checking" the other.
 */
export var BusinessFeeNegotiationParty;
(function (BusinessFeeNegotiationParty) {
    /** The merchant, acting from the business portal. */
    BusinessFeeNegotiationParty["Business"] = "BUSINESS";
    /** Afriex staff, acting from the admin portal (Sales or Finance). */
    BusinessFeeNegotiationParty["Afriex"] = "AFRIEX";
})(BusinessFeeNegotiationParty || (BusinessFeeNegotiationParty = {}));
//# sourceMappingURL=BusinessFeeNegotiationParty.js.map